var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusCrossGradiant(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.106018 0.205994C0.106018 0.205994 1.59201 12.106 9.14401 18.151C16.696 24.196 30.316 24.394 30.316 24.394V2.93201C30.316 2.93201 29.306 0.205994 27.065 0.205994H0.106018Z",
    fill: "url(#paint0_linear_48_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.581 5.995L21.87 13.284",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.044 5.995L14.755 13.284",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_48_2",
    x1: 0.106018,
    y1: 11.4776,
    x2: 30.3156,
    y2: 11.6662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11B700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCrossGradiant);
export default __webpack_public_path__ + "static/media/statusCrossGradiant.cb4f93ffcd9ea25153c6d58893e5d5ae.svg";
export { ForwardRef as ReactComponent };